App.filter('preparePersonsData', ['$filter', function ($filter) {
    return function (data, branchId) {
        if (!angular.isDefined(data.persons)) return data;

        data = angular.copy(data);

        var response = {declarations: []};

        angular.forEach(data.choose, function (singleChoose, chooseKey) {
            var singlePerson = data.persons[chooseKey];
            if (typeof singlePerson === "undefined") {
                return;
            }
            angular.forEach(singleChoose, function (insuranceId) {
                var agreements = singlePerson['agreements'];

                if (typeof singlePerson.type !== "undefined") {
                    var sameAsFirst = false;
                    if (angular.isDefined(agreements)) {
                        sameAsFirst = agreements.sameAsFirst;
                    }

                    if (sameAsFirst) {
                        agreements = data.persons[0]['agreements'];
                    }

                    switch (singlePerson.type) {
                        case 'USER':
                            if (data.person.type === 'SPOUSE') {
                                data['type'] = 'SPOUSE';
                            } else {
                                data['type'] = 'USER';
                            }
                            response.declarations.push(parse(data, insuranceId, branchId, agreements));
                            break;
                        case 'PARTNER':
                        case 'SPOUSE':
                            if (singlePerson.hideForm) {
                                break;
                            }
                            response.declarations.push(parse(singlePerson, insuranceId, branchId, agreements));
                            break;
                        case 'CHILD':
                            if (singlePerson.hideForm) {
                                break;
                            }
                            response.declarations.push(parse(singlePerson, insuranceId, branchId, agreements));
                            break;
                    }
                }
            });
        });

        return response;
    };

    function parse(data, insuranceId, branchId, agreements) {
        return {
            assured: data.isAssured ? assuredHandler(data.assured) : [],
            branch: branchHandler(branchId),
            lifeInsurance: lifeInsuranceHandler(insuranceId),
            partner: data.isPartner ? partnerHandler(data.partner) : null,
            person: personHandler(data.person),
            proposedDate: proposedDateHandler(data),
            type: typeHandler(data),
            marriageDate: extractMarriageDate(typeHandler(data), data.marriageDate ? data.marriageDate : data.person.marriageDate),
            employmentDate: extractDate(data.person.employmentDate),
            formOfEmployment: extract(data.person.formOfEmployment),
            otherFormOfEmployment: extractOtherFormOfEmployment(data.person.formOfEmployment, data.person.otherFormOfEmployment),
            optionalAgreementAccepted1: extractAgreement(agreements, 0),
            optionalAgreementAccepted2: extractAgreement(agreements, 1),
            optionalAgreementAccepted3: extractAgreement(agreements, 2),
            optionalAgreementAccepted4: extractAgreement(agreements, 3),
            optionalAgreementAccepted5: extractAgreement(agreements, 4),
            optionalAgreementAccepted6: extractAgreement(agreements, 5),
            optionalAgreementAccepted7: extractAgreement(agreements, 6),
            optionalAgreementAccepted8: extractAgreement(agreements, 7),
            oncologyAgreementAccepted: extractOncologyAgreement(agreements),
            cardiologyAgreementAccepted: extractCardiologyAgreement(agreements),
        };
    }

    // HANDLERS
    function assuredHandler(data) {
        return data.map(function (value) {
            return {
                apartment: extract(value.apartment),
                city: extractCity(value.city),
                country: extract(value.country),
                number: extract(value.number),
                organizationName: extract(value.organizationName),
                organizationREGON: extract(value.organizationREGON),
                percent: extract(value.percent),
                personBirthdate: extractBirthdate(value.personBirthdate),
                personBirthplace: extract(value.personBirthplace),
                personFirstName: extract(value.personFirstName),
                personLastName: extract(value.personLastName),
                post: extract(value.post), // @TODO: Missing parameter
                street: extract(value.street),
                type: value.type,
                zipCode: extract(value.zipCode),
                relationship: extract(value.relationship)
            }
        }).slice(0, 4);
    }

    function branchHandler(branchId) {
        return {id: branchId};
    }

    function lifeInsuranceHandler(insuranceId) {
        return {id: insuranceId};
    }

    function partnerHandler(data) {
        // @TODO: What to do with all these missing parameters?
        var identifierType = extractIdentifierType(data.citizenshipType);
        var identifier = extractIdentifier(identifierType, data.identifier);
        var citizenshipType = extract(data.citizenshipType);
        return {
            address: data.address ? {
                apartment: extract(data.address.apartment), // @TODO: Missing
                city: extractCity(data.address.city), // @TODO: Missing
                country: extract(data.address.country), // @TODO: Missing
                number: extract(data.address.number), // @TODO: Missing
                post: extract(data.address.post), // @TODO: Missing
                street: extract(data.address.street), // @TODO: Missing
                zipCode: extract(data.address.zipCode) // @TODO: Missing
            } : null,
            birthdate: extractBirthdate(data.birthdate, identifierType, identifier),
            birthplace: extract(data.birthplace),
            citizenshipType: citizenshipType,
            email: extract(data.email), // @TODO: Missing
            firstName: extract(data.firstName),
            gender: extractGender(data.citizenshipType, data.identifier, data.gender),
            identifier: identifier,
            identifierType: identifierType,
            lastName: extract(data.lastName),
            mothersMaidenName: extract(data.mothersMaidenName), // @TODO: Missing
            otherCitizenship: extractOtherCitizenship(data.otherCitizenship, citizenshipType),
            phone: extract(data.phone) // @TODO: Missing
        };
    }

    function personHandler(data) {
        // @TODO: What to do with all these missing parameters?
        var identifierType = extractIdentifierType(data.citizenshipType);
        var identifier = extractIdentifier(identifierType, data.identifier);
        var citizenshipType = extract(data.citizenshipType);
        return {
            address: data.address ? {
                apartment: extract(data.address.apartment),
                city: extractCity(data.address.city),
                country: extract(data.address.country), // @TODO: Should be 'POLISH' or 'OTHER' like in case of the citizenship?
                number: extract(data.address.number),
                post: extract(data.address.post),
                street: extract(data.address.street),
                zipCode: extract(data.address.zipCode)
            } : null,
            birthdate: extractBirthdate(data.birthdate, identifierType, identifier),
            birthplace: extract(data.birthplace),
            citizenshipType: citizenshipType,
            email: extract(data.email),
            firstName: extract(data.firstName),
            gender: extractGender(data.citizenshipType, data.identifier, data.gender),
            identifier: identifier,
            identifierType: identifierType,
            lastName: extract(data.lastName),
            mothersMaidenName: extract(data.mothersMaidenName), // @TODO: Missing
            otherCitizenship: extractOtherCitizenship(data.otherCitizenship, citizenshipType),
            phone: extract(data.phone) // @TODO: Missing
        };
    }

    function proposedDateHandler() {
        var date = new Date();
        var dayOfMonth = date.getDate();
        var requiredDayOfMonth = 20;
        var proposedDate = null;

        if (dayOfMonth <= requiredDayOfMonth) {
            // to najbliższy
            var date = new Date(date.getFullYear(), date.getMonth() + 1);
            var formattedDate = moment(date).format('YYYY-MM-DD');
            proposedDate = formattedDate;
        } else {
            // to +1 miesiąc
            var date = new Date(date.getFullYear(), date.getMonth() + 2);
            var formattedDate = moment(date).format('YYYY-MM-DD');
            proposedDate = formattedDate;
        }

        return proposedDate;
    }

    function typeHandler(data) {
        return data.type;
    }

    // HELPERS
    function extract(rootValue) {
        if (angular.isDefined(rootValue)) return rootValue;
        return null;
    }

    function extractOtherFormOfEmployment(formOfEmployment, otherFormOfEmployment) {
        if (angular.isDefined(formOfEmployment) && angular.isDefined(otherFormOfEmployment) && formOfEmployment === 'OTHER') {
            return otherFormOfEmployment;
        }
        return null;
    }

    function extractOtherCitizenship(rootValue, citizenshipType) {
        if (citizenshipType !== 'OTHER') {
            return null;
        }
        return extract(rootValue);
    }

    function extractIdentifier(identifierType, identifier) {
        // if(identifierType !== 'PESEL'){
        //     return null;
        // }
        return identifier;
    }

    function extractMarriageDate(personType, marriageDate) {
        if (personType !== 'SPOUSE') {
            return null;
        }
        return extractDate(marriageDate);
    }

    function extractDate(_date) {
        if (!angular.isDefined(_date)) return null;
        return $filter('getDateFromBirthdate')(_date);
        // if (angular.isDate(_date)) {
        //     var mm = _date.getMonth() + 1; // getMonth() is zero-based
        //     var dd = _date.getDate();
        //
        //     return [_date.getFullYear(),
        //         (mm > 9 ? '' : '0') + mm,
        //         (dd > 9 ? '' : '0') + dd
        //     ].join('-');
        // }
        // return _date.substring(0, 10);
    }

    function extractBirthdate(rootBirthdate, identifierType, identifier) {
        identifierType = identifierType || 'OTHER';
        if (identifierType === 'PESEL') {
            if (!identifier) {
                return null;
            }
            return $filter('getDateFromIdentifier')(identifier);
        }
        return extractDate(rootBirthdate);
    }

    function extractIdentifierType(citizenshipType) {
        if (!angular.isDefined(citizenshipType)) return 'OTHER';
        if (citizenshipType === 'POLISH') {
            return 'PESEL';
        }
        return 'OTHER';
    }

    function extractGender(citizenshipType, identifier, gender) {
        var type = extractIdentifierType(citizenshipType);
        if (type === 'PESEL') {
            if (!identifier) {
                return null;
            }
            return parseInt(identifier.substring(9, 10), 10) % 2 === 1 ? 'MALE' : 'FEMALE';
        } else {
            return extract(gender);
        }
    }

    function extractCity(rootCity) {
        if (angular.isDefined(rootCity)) {
            if (angular.isString(rootCity)) {
                return rootCity;
            }
            if (!rootCity) {
                return null;
            }
            if (angular.isDefined(rootCity.name)) {
                return rootCity.name;
            }
        }
        return null;
    }

    function extractAgreement(agreements, index) {
        if (!angular.isDefined(agreements)
            || !angular.isDefined(agreements.list)
            || !angular.isDefined(agreements.list[index])
            || !angular.isDefined(agreements.list[index].accepted)) {
            if (!angular.isDefined(agreements)
                || !angular.isDefined(agreements.optionalAgreementsList)
                || !angular.isDefined(agreements.optionalAgreementsList[index])
                || !angular.isDefined(agreements.optionalAgreementsList[index].accepted)) {
                return false;
            } else {
                return agreements.optionalAgreementsList[index].accepted;
            }
        }
        return agreements.list[index].accepted;
    }

    function extractOncologyAgreement(agreements) {
        if (!angular.isDefined(agreements)
            || !angular.isDefined(agreements.oncologyPackage)) {
            return false;
        }
        return agreements.oncologyPackage;
    }

    function extractCardiologyAgreement(agreements) {
        if (!angular.isDefined(agreements)
            || !angular.isDefined(agreements.cardiologyPackage)) {
            return false;
        }
        return agreements.cardiologyPackage;
    }
}]);
